// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchResultBlock_container__8Q3w7"};